import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import Line from 'src/models/line';
import { List } from 'linqts';

@Component({
  selector: 'app-line-picker',
  templateUrl: './line-picker.component.html',
  styleUrls: ['./line-picker.component.scss']
})
export class LinePickerComponent implements OnInit {
  linesByFactory: { [key: string]: Line[]; } = {};
  getLinesPromise: Promise<Line[]> | null = null;

  private _selectedFactoryName: string | null = null;
  get selectedFactoryName(): string | null { return this._selectedFactoryName; }
  set selectedFactoryName(value: string | null) {
    this._selectedFactoryName = value;
    this.selectedLine = this.lineOptions[0] || null;
  }

  _selectedLine: Line | null = null;
  get selectedLine(): Line | null { return this._selectedLine; }
  set selectedLine(value: Line | null) { this._selectedLine = value; }

  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<LinePickerComponent>,
    @Inject(MAT_DIALOG_DATA) public preselectedLineId: string | null
  ) { }

  async ngOnInit(): Promise<void> {
    await this.loadData();
  }

  loadData = async () => {

    this.getLinesPromise = this.apiService.getLines();
    try {
      const lines = await this.getLinesPromise;
      this.linesByFactory = new List(lines).ToLookup(item => item.factoryName, item => item);
      this.getLinesPromise = null;

      const preselectedLine = lines.find(item => item.id === this.preselectedLineId);

      this.selectedFactoryName = preselectedLine?.factoryName || null;
      this.selectedLine = preselectedLine || null;

    } catch {
      // do nothing for now
    }
  }

  async onSubmit(event: MouseEvent) {

  }

  get factoryNames(): string[] {
    return Object.keys(this.linesByFactory).sort();
  }

  get lineOptions(): Line[] {
    return this.linesByFactory[this.selectedFactoryName || ''] || [];
  }

  get canSubmit(): boolean {
    return !!this.selectedLine;
  }

  getResult = (): Line => {
    return this.selectedLine!;
  }

  static Open(dialog: MatDialog, preselectedLineId: string | null): MatDialogRef<LinePickerComponent, Line | null> {
    return dialog.open<LinePickerComponent, string | null, any>(
      LinePickerComponent,
      {
        data: preselectedLineId
      });
  }
}
